// extracted by mini-css-extract-plugin
export default {"Products":"Products_Products__gmRgg","rotate-center":"Products_rotate-center__sP8B+","text":"Products_text__fCSMC"};